import { TuiInput } from '@taiga-ui/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { PatientFormResponse } from '@pixacare/dtos';
import { DepositHttpService } from '@services/http/deposit.http.service';
import { TuiChevron, TuiDataListWrapper, TuiSelect } from '@taiga-ui/kit';
import { shareReplay } from 'rxjs';

type OnChangeFn = (value: PatientFormResponse) => void;

@Component({
  selector: 'pxc-form-select',
  imports: [
    CommonModule,
    TuiInput,
    TuiChevron,
    TuiDataListWrapper,
    TuiSelect,
    FormsModule,
    ReactiveFormsModule,
    TranslocoDirective,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FormSelectComponent,
    },
  ],
  templateUrl: './form-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSelectComponent implements ControlValueAccessor {
  readonly items$ = inject(DepositHttpService).getForms().pipe(shareReplay(1));
  readonly translocoService = inject(TranslocoService);

  @Input() placeholder = this.translocoService.translate('Sélectionnez un questionnaire');

  disabled = false;
  touched = false;
  value: PatientFormResponse;

  onChange: OnChangeFn = () => {};
  onTouched: () => void = () => {};

  writeValue(obj: PatientFormResponse): void {
    this.value = obj;
  }

  registerOnChange(fn: OnChangeFn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  stringify(item: PatientFormResponse): string {
    return item.form?.title;
  }

  onSelectChange(value: PatientFormResponse): void {
    this.touched = true;
    this.onChange(value);
  }
}
